var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.456,
    height: 74.456,
    viewBox: "0 0 74.456 74.456",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1362",
    "data-name": "Raggruppa 1362",
    transform: "translate(2336.859 -622.235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1337",
    "data-name": "Raggruppa 1337",
    transform: "translate(-2336.859 622.235)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_869",
    "data-name": "Rettangolo 869",
    width: 74.456,
    height: 74.456,
    transform: "translate(0)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1804",
    "data-name": "Tracciato 1804",
    d: "M23.789,31.657c-3.581,3.921-7.075,7.746-10.57,11.57C11.4,45.221,9.576,47.218,7.737,49.2a1.472,1.472,0,0,1-.836.536c-1.963.048-3.929.025-6.2.025C7.514,42.3,14.155,35.025,20.839,27.706,13.909,18.5,7.023,9.345,0,.015H1.139C6.2.015,11.251.026,16.308,0a1.553,1.553,0,0,1,1.412.712q5.976,7.973,12,15.911c.151.2.319.387.557.675.5-.525.981-1.009,1.442-1.511Q38.694,8.2,45.646.6A1.654,1.654,0,0,1,47.039,0c1.8.032,3.612.011,5.7.011l-19.5,21.282L54.589,49.682c-.41.034-.674.076-.937.076-5.089,0-10.175-.008-15.264.017a1.665,1.665,0,0,1-1.5-.761q-6.2-8.28-12.451-16.527c-.189-.25-.385-.494-.647-.83ZM46.7,46c-.294-.422-.464-.681-.649-.929C36.261,32.071,26.437,19.1,16.723,6.04c-1.265-1.7-2.5-2.625-4.661-2.322a30.789,30.789,0,0,1-4.11.032c.271.395.4.6.549.8q6.966,9.258,13.932,18.515,8.4,11.159,16.826,22.3a1.5,1.5,0,0,0,.952.6C42.308,46.026,44.4,46,46.7,46Z",
    transform: "translate(10.069 12.68)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0d1c87b765c21eee7bd2c7fe214bcc4c.svg";
export { ForwardRef as ReactComponent };